import {
    SETTINGS_CONSTRUCTOR_MODULES_LIMIT,
    SETTINGS_CONSTRUCTOR_PAGES_LIMIT,
    SETTINGS_CONSTRUCTOR_SECTIONS_LIMIT,
} from '../../constants';
import { useSettingsFactory } from './useSettingsFactory';

export const useSettingsConstructorLimits = () => {
    const {
        values: { pagesLimit, sectionsLimit, modulesLimit },
    } = useSettingsFactory({
        pagesLimit: {
            path: SETTINGS_CONSTRUCTOR_PAGES_LIMIT,
        },
        sectionsLimit: {
            path: SETTINGS_CONSTRUCTOR_SECTIONS_LIMIT,
        },
        modulesLimit: {
            path: SETTINGS_CONSTRUCTOR_MODULES_LIMIT,
        },
    });

    return {
        pagesLimit: pagesLimit.value as number | undefined,
        sectionsLimit: sectionsLimit.value as number | undefined,
        modulesLimit: modulesLimit.value as number | undefined,
    };
};
